import { useEffect } from "react";

const MS_PHOTO =
  "https://storage.readdy-site.link/project_files/5f999b58-37af-4b7c-93ed-b1c1edf1d4e9/2811783a-c641-43a3-a82d-0bfc5889f887_file_1773888459816.png?v=48a92851cf2cb822d21f51fa5e83d1ea";

export default function MeetMsWashington() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.15 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className="py-24 md:py-36 relative overflow-hidden"
      style={{ background: "#111111" }}
    >
      {/* Background glow */}
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-96 h-96 rounded-full bg-gold/5 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Photo */}
          <div className="reveal flex justify-center lg:justify-end order-2 lg:order-1">
            <div className="relative">
              {/* Glow ring */}
              <div
                className="absolute -inset-3 rounded-3xl"
                style={{
                  background:
                    "linear-gradient(135deg, rgba(147,51,234,0.4), transparent, rgba(147,51,234,0.2))",
                  filter: "blur(20px)",
                }}
              />
              <div className="relative w-72 h-96 md:w-80 md:h-[440px] rounded-3xl overflow-hidden border-2 border-gold/30">
                <img
                  src={MS_PHOTO}
                  alt="MsWashington — Founder & Creative Director of LittyCity Agency LLC"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Gold badge */}
              <div className="absolute -bottom-4 -right-4 bg-gold text-white px-5 py-3 rounded-2xl">
                <p className="font-display font-bold text-sm leading-tight">Founder &</p>
                <p className="font-display font-bold text-sm leading-tight">Creative Director</p>
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="reveal reveal-delay-1 order-1 lg:order-2">
            <span className="text-gold text-xs font-sans font-semibold tracking-[0.3em] uppercase block mb-6">
              Leadership
            </span>
            <h2
              className="font-display font-black text-white leading-tight mb-4"
              style={{ fontSize: "clamp(2rem, 4vw, 3.2rem)" }}
            >
              Meet{" "}
              <span className="text-gradient-gold">MsWashington</span>
            </h2>
            <p className="text-gold font-sans font-medium text-lg mb-2 tracking-wide">
              Founder &amp; Creative Director
            </p>
            <div className="w-20 h-0.5 bg-gold mb-8" />
            <p className="text-white/65 font-sans text-lg leading-relaxed mb-6">
              MsWashington is a creative director, strategist, and agency leader
              dedicated to helping creators unlock their potential and build
              sustainable digital careers.
            </p>
            <p className="text-white/55 font-sans text-base leading-relaxed mb-8">
              With a passion for community building and a deep understanding of
              the digital creator landscape, she founded The LittyCity Agency
              LLC in 2024 to provide the structure, mentorship, and real
              opportunities that creators deserve.
            </p>

            <div className="flex flex-wrap gap-3">
              {["Creative Director", "Strategist", "Digital Innovator", "Community Builder"].map(
                (tag) => (
                  <span
                    key={tag}
                    className="px-4 py-1.5 rounded-full border border-gold/30 text-gold/80 text-xs font-sans font-medium tracking-wide"
                  >
                    {tag}
                  </span>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
